import { connect } from 'react-redux';

import InfoPage from '../components/InfoPage';

@connect(function ({ router }) {
  return {
    router,
  };
})
export default class InfoPageContainer extends InfoPage {}
